import React from "react";
import { Link } from "react-router-dom";
const Failed = () => {
  return (
    <>
   
      <section className="section-space">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="PayResult failed">
              <i className="bi bi-exclamation-triangle"></i>
              <h1>Payment Failed!</h1>
              <p>We’re sorry, but your transaction could not be processed. Please try again or contact support for assistance.</p>
              </div>
            </div>
           
          </div>
        </div>
      </section>
    </>
  );
};

export default Failed;
